import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import styles from './StatisticInfo.module.scss';
import React from 'react';
import { getMatchDescription } from '../../../../../../utils/render';

const StatisticInfo = ({ statistics }) => {
    const { theme, locale } = useSelector(state => state.settings);

    const period = getMatchDescription(statistics.matchStatusCode, {
        type: 'short',
        locale,
    });

    return (
        <>
            <ReactTooltip
                id={'statisticsInfo'}
                place='top'
                type={theme ? 'dark' : 'light'}
                aria-haspopup='true'
                className={styles.eventNameTooltip}
            />
            <div data-tip={period} data-for='statisticsInfo' className={styles.name}>
                {period}
            </div>
        </>
    );
};

export default StatisticInfo;
